import React from 'react';

export default () => {
    return <div style={{ paddingTop: '50px' }}>&nbsp;</div>;
};
